import { LetterlistTableColumnSettingType } from "features/Letterbooks/types";
import { UserSerializersUserByline } from "types/serializers";

export function appendUserToColumn(
  column: LetterlistTableColumnSettingType,
  user: UserSerializersUserByline
) {
  return {
    ...column,
    ...{ user },
  };
}
export function appendUserToColumns(
  columns: LetterlistTableColumnSettingType[],
  user: UserSerializersUserByline
) {
  return columns.map((column) => appendUserToColumn(column, user));
}

export function calculateUnusedColumns(
  tableColumns: LetterlistTableColumnSettingType[],
  possibleColumns: LetterlistTableColumnSettingType[]
) {
  const tableColumnKeys = tableColumns.map((column) => column.key);
  return possibleColumns
    .filter((column) => tableColumnKeys.indexOf(column.key) === -1)
    .sort((a, b) => a.title.localeCompare(b.title));
}
